import { MESSAGE_PAGE_LIMIT } from "./chatScrollConstants";

export const getMessagesPayload = (response) => response?.data ?? response ?? {};
export const getMessageItems = (response) => getMessagesPayload(response)?.items ?? [];
export const getPaginationData = (response) => getMessagesPayload(response)?.pagination ?? null;

export const toTimestamp = (value) => {
  const ts = new Date(value).getTime();
  return Number.isFinite(ts) ? ts : 0;
};

export const mergeUniqueMessages = (currentMessages, incomingMessages) => {
  const map = new Map();
  currentMessages.forEach((message) => {
    if (message?.id) map.set(message.id, message);
  });
  incomingMessages.forEach((message) => {
    if (message?.id) map.set(message.id, message);
  });
  return Array.from(map.values()).sort((a, b) => {
    const diff = toTimestamp(a?.createdAt) - toTimestamp(b?.createdAt);
    if (diff !== 0) return diff;
    return String(a?.id ?? "").localeCompare(String(b?.id ?? ""));
  });
};

export const createDefaultPagination = () => ({
  nextCursor: null,
  prevCursor: null,
  hasNextPage: false,
  hasPrevPage: false,
  limit: MESSAGE_PAGE_LIMIT,
  direction: "next",
});
